import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="#000"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M455.773 255.789c0 110.535-89.602 200.138-200.132 200.138-110.54 0-200.142-89.603-200.142-200.138S145.101 55.652 255.641 55.652c110.53 0 200.132 89.602 200.132 200.137z"
      />
      <path
        fill="none"
        stroke="#000"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M255.31 149.056c-58.894.146-106.527 47.999-106.393 106.901.132 58.902 47.984 106.549 106.889 106.403 58.903-.146 106.538-47.999 106.404-106.9-.145-58.903-47.986-106.55-106.9-106.404z"
      />
      <path
        fill="none"
        stroke="#000"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M247.433 209.307c-1.766 0-3.777-.998-5.662-2.81l-.137-.132-25.858-23.143-17.719-17.168a105.995 105.995 0 0 1 57.175-16.77c8.687 0 17.297 1.057 25.717 3.151l-11.098 22.136-16.478 29.814-.099.197c-.882 1.765-2.814 4.725-5.841 4.725 0 0 0 0 0 0zm89.83 34.124-34.127-6.632-.238-.035c-2.939-.435-5.061-1.631-5.98-3.367-.932-1.764-.715-4.242.613-6.978l.092-.188 13.655-31.198 10.819-22.204c22.746 18.309 37.097 45.307 39.485 74.263l-24.319-3.661zm-44.96 87.31-4.609-36.452-.034-.207c-.467-2.806-.048-5.148 1.179-6.597 1.356-1.6 3.547-1.937 5.145-1.937.577 0 1.184.044 1.805.131l.213.029 34.145 3.348 25.282 3.593a97.76 97.76 0 0 1-4.313 10.226c-11.558 23.417-30.836 41.209-54.994 51.018l-3.819-23.152zm-139.177-47.709c-6.879-25.226-4.482-51.405 7.056-74.852a96.621 96.621 0 0 1 5.417-9.606l17.221 17.04 24.391 26.087.147.145c2.112 2.091 3.118 4.327 2.833 6.294-.287 1.976-1.895 3.841-4.527 5.252l-.184.099-29.503 17.329-22.851 12.212zm97.707 78.765c-15.136-.546-29.415-4.09-42.501-10.553-13.175-6.565-24.609-15.765-34.094-27.419l21.391-11.107 32.716-15.361.143-.072c1.632-.827 3.23-1.264 4.622-1.264 4.092 0 5.399 3.974 5.814 6.343l.037.211 7.684 35.469 4.188 23.753z"
      />
    </svg>
  );
};

export default Icon;
